import React, { useEffect, useRef, useState } from "react";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Tab,
    TextField,
    Menu,
    MenuItem,
    Typography
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import Grid from "@mui/material/Grid";
import TabContext from "@mui/lab/TabContext";
import Box from "@mui/material/Box";
import './meals.css';

const MEAL_STATUSES = [
    { value: 0, label: "💡 Idea / Unplanned", color: "#64748b", bg: "rgba(100, 116, 139, 0.1)" },
    { value: 1, label: "⏳ Looking for Table", color: "#f59e0b", bg: "rgba(245, 158, 11, 0.1)" },
    { value: 2, label: "📞 Reservation Requested", color: "#3b82f6", bg: "rgba(59, 130, 246, 0.1)" },
    { value: 3, label: "✅ Confirmed", color: "#10b981", bg: "rgba(16, 185, 129, 0.1)" },
    { value: 4, label: "🍽️ Seated / Active", color: "#8b5cf6", bg: "rgba(139, 92, 246, 0.1)" },
    { value: 5, label: "🏁 Completed & Settled", color: "#ec4899", bg: "rgba(236, 72, 153, 0.1)" },
    { value: 6, label: "⚠️ Delayed / Running Late", color: "#d97706", bg: "rgba(217, 119, 6, 0.1)" },
    { value: 7, label: "❌ Cancelled by Us", color: "#ef4444", bg: "rgba(239, 68, 68, 0.1)" },
    { value: 8, label: "🚫 Cancelled by Venue", color: "#b91c1c", bg: "rgba(185, 28, 28, 0.1)" }
];

function MealDialogEditDetails({ isOpen, onClose, eventMeal, setEventMeal }) {
    const [tabValueDetails, setTabValueDetails] = useState("dine_out"); //[cite: 3]
    const [bookedThrough, setBookedThrough] = useState(""); //[cite: 3]
    const [confirmationNumber, setConfirmationNumber] = useState(""); //[cite: 3]
    const [reservationName, setReservationName] = useState(""); //[cite: 3]
    const [reservationNumber, setReservationNumber] = useState(""); //[cite: 3]
    const [notes, setNotes] = useState(""); //[cite: 3]
    const [stayingInDetails, setStayingInDetails] = useState(""); //[cite: 3]

    const [mealStatus, setMealStatus] = useState(0);
    const [anchorStatusEl, setAnchorStatusEl] = useState(null);

    useEffect(() => {
        if (isOpen && eventMeal) {
            setBookedThrough(eventMeal.booked_through || ""); //[cite: 3]
            setConfirmationNumber(eventMeal.confirmation_number || ""); //[cite: 3]
            setReservationName(eventMeal.reservation_name || ""); //[cite: 3]
            setReservationNumber(eventMeal.reservation_number || ""); //[cite: 3]
            setNotes(eventMeal.notes || ""); //[cite: 3]
            setStayingInDetails(eventMeal.eat_in_details || ""); //[cite: 3]
            setMealStatus(typeof eventMeal.status === "number" ? eventMeal.status : 0);
            setTabValueDetails(eventMeal.eat_in ? "im_cooking" : "dine_out"); //[cite: 3]

            initialValues.current = {
                bookedThrough: eventMeal.booked_through || "", //[cite: 3]
                confirmationNumber: eventMeal.confirmation_number || "", //[cite: 3]
                reservationName: eventMeal.reservation_name || "", //[cite: 3]
                reservationNumber: eventMeal.reservation_number || "", //[cite: 3]
                notes: eventMeal.notes || "", //[cite: 3]
                stayingInDetails: eventMeal.eat_in_details || "", //[cite: 3]
                mealStatus: typeof eventMeal.status === "number" ? eventMeal.status : 0
            };
        }
    }, [isOpen, eventMeal]);

    const handleTabValueDetailsChange = (event, newValue) => { //[cite: 3]
        setTabValueDetails(newValue); //[cite: 3]
    };

    const initialValues = useRef({ //[cite: 3]
        bookedThrough: "",
        confirmationNumber: "",
        reservationName: "",
        reservationNumber: "",
        notes: "",
        stayingInDetails: "",
        mealStatus: 0
    });

    const handleOpenStatusMenu = (event) => setAnchorStatusEl(event.currentTarget);
    const handleCloseStatusMenu = () => setAnchorStatusEl(null);
    const handleSelectStatus = (statusValue) => {
        setMealStatus(statusValue);
        handleCloseStatusMenu();
    };

    function handleBookedThroughChange(event) { setBookedThrough(event.target.value); } //[cite: 3]
    function handleConfirmationNumberChange(event) { setConfirmationNumber(event.target.value); } //[cite: 3]
    function handleReservationNameChange(event) { setReservationName(event.target.value); } //[cite: 3]
    function handleReservationNumberChange(event) { setReservationNumber(event.target.value); } //[cite: 3]
    function handleNotesChange(event) { setNotes(event.target.value); } //[cite: 3]
    function handleStayingInDetailsChange(event) { setStayingInDetails(event.target.value); } //[cite: 3]

    function saveEventMealSettings() { //[cite: 3]

        const updatedMeal = {
            ...eventMeal,
            booked_through: bookedThrough, //[cite: 3]
            confirmation_number: confirmationNumber, //[cite: 3]
            reservation_name: reservationName, //[cite: 3]
            reservation_number: reservationNumber, //[cite: 3]
            notes: notes, //[cite: 3]
            eat_in_details: stayingInDetails, //[cite: 3]
            eat_in: tabValueDetails === "im_cooking", //[cite: 3]
            status: mealStatus
        };

        setEventMeal(updatedMeal);

        initialValues.current = { //[cite: 3]
            bookedThrough, //[cite: 3]
            confirmationNumber, //[cite: 3]
            reservationName, //[cite: 3]
            reservationNumber, //[cite: 3]
            notes, //[cite: 3]
            stayingInDetails, //[cite: 3]
            mealStatus
        };

        onClose(); //[cite: 3]
    }

    const currentStatusObject = MEAL_STATUSES.find(s => s.value === mealStatus) || MEAL_STATUSES[0];

    return (
        <Dialog
            open={isOpen} //[cite: 3]
            onClose={onClose} //[cite: 3]
            PaperProps={{
                sx: {
                    minWidth: 350, //[cite: 3]
                    maxWidth: 500, //[cite: 3]
                    width: '100%', //[cite: 3]
                    borderRadius: '24px',
                    background: 'rgba(255, 255, 255, 0.85)',
                    backdropFilter: 'blur(25px)',
                    border: '1px solid rgba(255, 255, 255, 0.4)',
                    boxShadow: '0 20px 40px rgba(0,0,0,0.15)',
                },
            }}
        >
            <DialogTitle
                sx={{
                    color: '#1e293b',
                    textAlign: 'center',
                    fontWeight: 800,
                    fontSize: '1.2rem',
                    pt: 3,
                    pb: 1
                }}
            >
                Meal Details Configuration
            </DialogTitle>

            <IconButton
                aria-label="close" //[cite: 3]
                onClick={onClose} //[cite: 3]
                sx={{ position: 'absolute', right: 16, top: 16, color: '#64748b' }}
            >
                <i className="icon-cross" style={{ fontSize: '14px' }} />
            </IconButton>

            <DialogContent> {/*[cite: 3] */}
                {/* Status Selector Dropdown */}
                <Box
                    sx={{
                        p: 1.5,
                        mb: 2.5,
                        borderRadius: '16px',
                        background: 'rgba(255, 255, 255, 0.45)',
                        border: '1px solid rgba(255, 255, 255, 0.6)',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        gap: 1
                    }}
                >
                    <Typography sx={{ fontSize: '13px', fontWeight: 700, color: '#475569', pl: 0.5 }}>
                        Meal Progress Status:
                    </Typography>

                    <Button
                        variant="text"
                        onClick={handleOpenStatusMenu}
                        sx={{
                            backgroundColor: currentStatusObject.bg,
                            color: currentStatusObject.color,
                            fontWeight: 800,
                            fontSize: '12px',
                            textTransform: 'none',
                            borderRadius: '10px',
                            px: 2,
                            py: 0.75,
                            border: `1px solid ${currentStatusObject.color}20`,
                            '&:hover': { backgroundColor: currentStatusObject.bg, opacity: 0.85 }
                        }}
                    >
                        {currentStatusObject.label} ▾
                    </Button>

                    <Menu
                        anchorEl={anchorStatusEl}
                        open={Boolean(anchorStatusEl)}
                        onClose={handleCloseStatusMenu}
                        PaperProps={{ sx: { borderRadius: '14px', p: 0.5, maxHeight: 280, boxShadow: '0 10px 25px rgba(0,0,0,0.08)' } }}
                    >
                        {MEAL_STATUSES.map((status) => (
                            <MenuItem
                                key={status.value}
                                onClick={() => handleSelectStatus(status.value)}
                                selected={status.value === mealStatus}
                                sx={{
                                    fontSize: '13px',
                                    fontWeight: 700,
                                    borderRadius: '8px',
                                    my: 0.25,
                                    color: status.color,
                                    '&.Mui-selected': { backgroundColor: status.bg },
                                    '&:hover': { backgroundColor: status.bg }
                                }}
                            >
                                {status.label}
                            </MenuItem>
                        ))}
                    </Menu>
                </Box>

                <TabContext value={tabValueDetails}> {/*[cite: 3] */}
                    <TabList
                        sx={{
                            mb: 2,
                            minHeight: '40px',
                            '& .MuiTabs-indicator': {
                                background: 'linear-gradient(135deg, #f09637 0%, #f2a654 100%)',
                                height: '3px',
                                borderRadius: '3px'
                            }
                        }}
                        centered //[cite: 3]
                        variant="fullWidth" //[cite: 3]
                        onChange={handleTabValueDetailsChange} //[cite: 3]
                        aria-label="Meal Details" //[cite: 3]
                    >
                        <Tab
                            label="Dine Out Options"
                            value="dine_out" //[cite: 3]
                            sx={{ textTransform: 'none', fontWeight: 700, fontSize: '13px', color: '#64748b', '&.Mui-selected': { color: '#f09637' } }}
                        />
                        <Tab
                            label="Meal In / Catering"
                            value="im_cooking" //[cite: 3]
                            sx={{ textTransform: 'none', fontWeight: 700, fontSize: '13px', color: '#64748b', '&.Mui-selected': { color: '#f09637' } }}
                        />
                    </TabList>

                    <TabPanel value="dine_out" sx={{ p: 0 }}> {/*[cite: 3] */}
                        <Grid container spacing={2}> {/*[cite: 3] */}
                            <Grid item xs={12} sm={6}> {/*[cite: 3] */}
                                <TextField
                                    fullWidth //[cite: 3]
                                    size="small"
                                    id="new_meal_booked_through" //[cite: 3]
                                    label="Booked Through" //[cite: 3]
                                    value={bookedThrough} //[cite: 3]
                                    onChange={handleBookedThroughChange} //[cite: 3]
                                    InputProps={{ sx: { borderRadius: '12px', background: '#fff' } }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}> {/*[cite: 3] */}
                                <TextField
                                    fullWidth //[cite: 3]
                                    size="small"
                                    id="new_meal_confirmation_number" //[cite: 3]
                                    label="Confirmation Number" //[cite: 3]
                                    value={confirmationNumber} //[cite: 3]
                                    onChange={handleConfirmationNumberChange} //[cite: 3]
                                    InputProps={{ sx: { borderRadius: '12px', background: '#fff' } }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}> {/*[cite: 3] */}
                                <TextField
                                    fullWidth //[cite: 3]
                                    size="small"
                                    id="new_meal_reservation_name" //[cite: 3]
                                    label="Reservation Name" //[cite: 3]
                                    value={reservationName} //[cite: 3]
                                    onChange={handleReservationNameChange} //[cite: 3]
                                    InputProps={{ sx: { borderRadius: '12px', background: '#fff' } }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}> {/*[cite: 3] */}
                                <TextField
                                    fullWidth //[cite: 3]
                                    size="small"
                                    id="new_meal_reservation_number" //[cite: 3]
                                    label="Reservation Phone/Number" //[cite: 3]
                                    value={reservationNumber} //[cite: 3]
                                    onChange={handleReservationNumberChange} //[cite: 3]
                                    InputProps={{ sx: { borderRadius: '12px', background: '#fff' } }}
                                />
                            </Grid>
                            <Grid item xs={12}> {/*[cite: 3] */}
                                <TextField
                                    fullWidth //[cite: 3]
                                    id="new_meal_notes" //[cite: 3]
                                    label="Dine Out Notes" //[cite: 3]
                                    multiline //[cite: 3]
                                    rows={3} //[cite: 3]
                                    value={notes} //[cite: 3]
                                    onChange={handleNotesChange} //[cite: 3]
                                    InputProps={{ sx: { borderRadius: '12px', background: '#fff' } }}
                                />
                            </Grid>
                        </Grid>
                    </TabPanel>

                    <TabPanel value="im_cooking" sx={{ p: 0 }}> {/*[cite: 3] */}
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <TextField
                                    fullWidth //[cite: 3]
                                    id="staying_in" //[cite: 3]
                                    label="Delivery, Cooking, or Catering Arrangements"
                                    multiline //[cite: 3]
                                    rows={4} //[cite: 3]
                                    value={stayingInDetails} //[cite: 3]
                                    onChange={handleStayingInDetailsChange} //[cite: 3]
                                    InputProps={{ sx: { borderRadius: '12px', background: '#fff' } }}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    fullWidth //[cite: 3]
                                    id="new_meal_notes_in"
                                    label="General Notes"
                                    multiline //[cite: 3]
                                    rows={2}
                                    value={notes} //[cite: 3]
                                    onChange={handleNotesChange} //[cite: 3]
                                    InputProps={{ sx: { borderRadius: '12px', background: '#fff' } }}
                                />
                            </Grid>
                        </Grid>
                    </TabPanel>
                </TabContext>
            </DialogContent>

            <DialogActions sx={{ p: '0 24px 24px 24px', gap: 1 }}>
                <Button onClick={onClose} sx={{ color: '#64748b', fontWeight: 600, textTransform: 'none' }}> {/*[cite: 3] */}
                    Cancel
                </Button>
                <Button
                    onClick={saveEventMealSettings} //[cite: 3]
                    variant="contained" //[cite: 3]
                    sx={{
                        background: 'linear-gradient(135deg, #f09637 0%, #f2a654 100%)',
                        boxShadow: '0 4px 14px rgba(240, 150, 55, 0.3)',
                        borderRadius: '10px',
                        fontWeight: 700,
                        textTransform: 'none',
                        px: 3,
                        '&:hover': { background: 'linear-gradient(135deg, #e08526 0%, #f09637 100%)' }
                    }}
                >
                    Save Changes
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default MealDialogEditDetails;